'use memo';

import { Outlet, createFileRoute } from '@tanstack/react-router';
import { HStack } from '@/components/Layout';
import { InnerNavigation } from './-components/InnerNavigation';
export const Route = createFileRoute('/_staff/attendances/_layout/settings')({
  component: SettingsLayout
});
function SettingsLayout() {
  /**
   * items-start はサイドナビを内容高さのまま保つため。
   * 本文側だけ self-stretch でペインいっぱいに伸ばす。
   */
  return <HStack className="min-h-0 flex-1 items-start gap-10 px-12 py-6">
      <InnerNavigation />
      <div className="flex min-h-0 min-w-0 flex-1 flex-col self-stretch">
        <Outlet />
      </div>
    </HStack>;
}